
import { Invoice } from "@/types/payments";

export const sortInvoices = (invoices: Invoice[], sortBy: keyof Invoice | null, sortOrder: 'asc' | 'desc' | 'none') => {
  // If we're not sorting or sort order is 'none', return the original array
  if (!sortBy || sortOrder === 'none') {
    return invoices;
  }
  
  return [...invoices].sort((a, b) => {
    if (sortBy === "dueDate" || sortBy === "paymentDate") {
      const aDate = a[sortBy] ? new Date(a[sortBy] as string).getTime() : 0;
      const bDate = b[sortBy] ? new Date(b[sortBy] as string).getTime() : 0;
      return sortOrder === "asc" 
        ? aDate - bDate
        : bDate - aDate;
    }
    
    if (typeof a[sortBy] === 'string' && typeof b[sortBy] === 'string') {
      return sortOrder === "asc"
        ? (a[sortBy] as string).localeCompare(b[sortBy] as string)
        : (b[sortBy] as string).localeCompare(a[sortBy] as string);
    }
    
    return sortOrder === "asc"
      ? (a[sortBy] as number) - (b[sortBy] as number)
      : (b[sortBy] as number) - (a[sortBy] as number);
  });
};
